<template>
	<div class="container-fluid gl-section">
        <div class="hero main-section">
            <h1>{{ homepageContent.title }}</h1>

            <div class="subtitle1 col-12 col-lg-7" v-html="homepageContent.subtitle"></div>

            <div class="go-to">
                <router-link to="/about" class="btn btn-info">{{ homepageContent.toAboutUsBtn }}</router-link>
            </div>
        </div>

        <div class="main-section last-updates">
            <h2>{{ homepageContent.lastUpdatesTitle }}</h2>
            <b-row class="justify-content-around">
                <b-col cols="12" lg="4" class="py-4 py-lg-0 flex-container-center-center">
                    <b-img fluid rounded="circle" :src="require(`@/assets/img/${jewishHoliday.moments[0].thumbnail}`)" :alt="jewishHoliday.moments[0].name"></b-img>
                </b-col>
                <b-col cols="12" lg="6" class="flex-container-center-center">
                    <div>
                        <h3>{{ jewishHoliday.name }} {{ jewishHoliday.moments[0].name }}</h3>
                        <p class="p1" v-html="jewishHolidayShortDescription"></p>
                        <div class="read-more">
                            <router-link class="btn btn-primary" 
                                :to="{
                                    name: 'SubMomentDetails',
                                    params: { slug: jewishHoliday.slug, subMomentSlug: jewishHoliday.moments[0].slug },
                                    hash: '#subMoment'
                                }"  
                            >
                                {{ homepageContent.readMoreBtn }}
                            </router-link>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="justify-content-around mt-5">
                <b-col cols="12" lg="6" order="2" order-lg="1" class="flex-container-center-center">
                    <div>
                        <h3 v-if="event.name === homepageContent.checkForAnniversaries">{{ homepageContent.lastAnniversaryOrBirth }} {{ lastUpdatesName }}</h3>
                        <h3 v-else>{{ lastUpdatesName }} {{ event.moments[0].name }}</h3>
                        <p class="p1" v-html="eventShortDescription"></p>
                        <div class="read-more">
                            <router-link class="btn btn-primary" 
                                :to="{
                                    name: 'SubMomentDetails',
                                    params: { slug: event.slug, subMomentSlug: event.moments[0].slug },
                                    hash: '#subMoment'
                                }"
                            >
                                {{ homepageContent.readMoreBtn }}
                            </router-link>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" order="1" order-lg="2" class="py-4 py-lg-0 flex-container-center-center">
                    <b-img fluid rounded="circle" :src="require(`@/assets/img/${event.moments[0].thumbnail}`)" :alt="event.moments[0].name"></b-img>
                </b-col>
            </b-row>
        </div>

        <div class="our-selection main-section">
            <h2>{{ homepageContent.ourSelection }}</h2>
            <b-row>
                <b-col cols="12" md="6" lg="4" class="mx-auto"
                    v-for="momentSelected in ourSelection"
                    :key="momentSelected.slug"
                >
                    <div class="card">
                        <img :src="require(`@/assets/img/${momentSelected.thumbnail}`)" class="card-img-top" :alt="momentSelected.name">
                        <div class="card-body">
                            <h5 class="card-title">{{momentSelected.name}}</h5>
                            <p class="card-text">{{ createShortDescription(momentSelected.description) }}...</p>
                            <router-link class="btn btn-info" 
                                :to="{
                                    name: 'SubMomentDetails',
                                    params: { slug: momentSelected.slug, subMomentSlug: momentSelected.subMomentSlug },
                                    hash: '#subMoment'
                                }"
                            >
                                {{ homepageContent.readMoreBtn }}
                            </router-link>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
	</div>
</template>

<script>
// @ is an alias to /src
import store from '@/store'
export default {
    data() {
        return {
            homepageContent: store.homepage,
            ourSelection: store.ourSelection,
            jewishHoliday: {},
            event: {},
            lastUpdatesName: '',
            jewishHolidayShortDescription: '',
            eventShortDescription: ''
        }
    },
    methods: {
        createShortDescription(description, num = 255) {
            return description = description.substring(0, num).trim();
        },
        latestEntry(storeArr) {
            const latestDate = new Date(Math.max.apply(null, storeArr.map(e => {
                return new Date(e.lastUpdate);
            })));

            const latestEntry = storeArr.filter(e => {
                const date = new Date(e.lastUpdate);
                return date.getTime() == latestDate.getTime();
            })[0];

            if (latestEntry.name === this.homepageContent.checkForAnniversaries) {
                this.lastUpdatesName = this.homepageContent.anniversary;
            } 
            if (latestEntry.name === this.homepageContent.births) {
                this.lastUpdatesName = this.homepageContent.birth;
            }
            
            return latestEntry;
        },
        checkLastUpdatesName() {
            return this.lastUpdatesName !== '' ? this.lastUpdatesName : this.lastUpdatesName = this.event.name;
        }
    },
    beforeMount() {
        this.jewishHoliday = this.latestEntry(store.jewishHolidays);
        this.jewishHolidayShortDescription = this.createShortDescription(this.jewishHoliday.moments[0].description) + '...';
        this.event = this.latestEntry(store.events);
        this.eventShortDescription = this.createShortDescription(this.event.moments[0].description, 289) + '...';
        this.checkLastUpdatesName();
    }
};
</script>

<style scoped>
.main-section {
    padding: 20px;
}

.hero {
    background-color: #eeeeee;
}

.last-updates h2 {
    margin-bottom: 0;
}

.last-updates .row {
    min-height: 350px;
}

.read-more {
    padding-top: 15px;
    text-align: center;
}

.our-selection {
    background-color: #eeeeee;
}

.card {
    max-width: 270px;
    height: 100%;
    margin: 20px auto;
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    background-color: transparent;
    text-align: center;
}

.card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-img-top {
    height: 200px;
    box-shadow: 8px 8px 10px #888888;
}

@media only screen and (min-width: 768px){
    .main-section, .our-selection {
        padding: 15px;
    }

    h2 {
        margin-bottom: 40px;
    }
}

@media only screen and (min-width: 992px) {
    .card {
        margin-top: 0;
        margin-bottom: 0;
    }
}
</style>
